(function () {
  'use strict';

  // Fix: mega menu hover stability.
  //
  // Problem: <details> layout box = only the <summary> height. The dropdown is
  // position:absolute so it doesn't extend the details box. When the mouse moves
  // from the summary toward the dropdown it briefly exits the details bounding
  // box, firing mouseleave and closing the menu via theme.js.
  //
  // Additionally, .megamenu has pointer-events:none when closed (our click-
  // interception fix), so the standard mouseover recovery in theme.js cannot
  // fire for mega-menu items.
  //
  // Fix: on mouseleave, check whether the mouse position is inside the dropdown
  // area or whether relatedTarget is a descendant; if so, re-open in the next
  // animation frame (after theme.js has already removed `open`).

  function patchHoverMenu() {
    var allDetails = document.querySelectorAll(
      '[data-section-type="header"] details[data-hover="true"]'
    );
    if (!allDetails.length) return;

    allDetails.forEach(function (detail) {
      detail.addEventListener('mouseleave', function (e) {
        var dropdown = detail.querySelector('.megamenu, .site-nav__dropdown');
        if (!dropdown) return;

        // Case 1: relatedTarget is a DOM descendant (works when pointer-events are active)
        if (e.relatedTarget && detail.contains(e.relatedTarget)) {
          requestAnimationFrame(function () {
            if (!detail.hasAttribute('open')) detail.setAttribute('open', '');
          });
          return;
        }

        // Case 2: pointer-events:none on dropdown means relatedTarget won't point
        // at the dropdown. Check mouse position against dropdown's visual rect.
        var rect = dropdown.getBoundingClientRect();
        var buffer = 8; // px tolerance for subpixel gaps
        if (
          e.clientX >= rect.left - buffer &&
          e.clientX <= rect.right + buffer &&
          e.clientY >= rect.top - buffer &&
          e.clientY <= rect.bottom + buffer
        ) {
          requestAnimationFrame(function () {
            if (!detail.hasAttribute('open')) detail.setAttribute('open', '');
          });
        }
      });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      setTimeout(patchHoverMenu, 200);
    });
  } else {
    setTimeout(patchHoverMenu, 200);
  }
})();
